import { PagePaths } from '@/routes/page-paths';

export enum PostAuthReturnKind {
  WalletExport = 'wallet-export',
}

export type PostAuthReturnIntent =
  | { kind: PostAuthReturnKind.WalletExport }
  | { kind: 'passkeys-settings' };

export type PostAuthDestination =
  | { pathname: typeof PagePaths.settings; state: { openWalletExport: true } }
  | { pathname: typeof PagePaths.settings; state: { openPasskeys: true } };

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const hasOnlyKeys = (value: Record<string, unknown>, allowedKeys: string[]) =>
  Object.keys(value).every((key) => allowedKeys.includes(key));

export const parsePostAuthReturnIntent = (value: unknown): PostAuthReturnIntent | null => {
  if (!isRecord(value) || !hasOnlyKeys(value, ['kind'])) {
    return null;
  }

  if (value.kind === PostAuthReturnKind.WalletExport) {
    return { kind: PostAuthReturnKind.WalletExport };
  }

  return value.kind === 'passkeys-settings' ? { kind: 'passkeys-settings' } : null;
};

export const resolvePostAuthDestination = (intent: PostAuthReturnIntent): PostAuthDestination => {
  if (intent.kind === PostAuthReturnKind.WalletExport) {
    return { pathname: PagePaths.settings, state: { openWalletExport: true } };
  }

  return { pathname: PagePaths.settings, state: { openPasskeys: true } };
};
